/** Canonical product brand — live domain stays biogalfhomehealth.com until trainaifit.health is purchased. */
export const BRAND_DISPLAY = 'TrainAIfit.Health';
export const BRAND_DOMAIN = 'biogalfhomehealth.com';
export const BRAND_SHORT = 'TrainAIfit';
/** Original mark (black on white) — Copilot_20260913_173902, shown on a white plate in dark UI. */
export const BRAND_LOGO = '/brand/trainaifit-logo-20260913-copilot.png';
export const BRAND_SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL ||
  process.env.NEXT_PUBLIC_BASE_URL ||
  'https://www.biogalfhomehealth.com';
